(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tayf-cart-drawer"]) return;
  try {
    
(function () {
  'use strict';

  class TayfCartDrawer {
    constructor() {
      this.overlay = document.querySelector('[data-drawer-overlay]');
      this.drawer = document.querySelector('[data-cart-drawer]');
      if (!this.drawer || !this.overlay) return;

      this._bindEvents();
      this._listenForOpen();
    }

    _bindEvents() {
      // Delegated close triggers (header button + continue shopping)
      this.drawer.addEventListener('click', e => {
        if (e.target.closest('[data-drawer-close]')) this.close();
      });
      this.overlay.addEventListener('click', () => this.close());

      document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && this.drawer.classList.contains('is-open')) this.close();
      });

      // Delegated: remove item
      this.drawer.addEventListener('click', async e => {
        const removeBtn = e.target.closest('[data-remove-item]');
        if (removeBtn) {
          removeBtn.disabled = true;
          await this._removeItem(removeBtn.dataset.removeItem);
        }

        const quickAdd = e.target.closest('[data-quick-add]');
        if (quickAdd) {
          quickAdd.classList.add('is-loading');
          await this._quickAdd(quickAdd.dataset.quickAdd);
          quickAdd.classList.remove('is-loading');
        }

        const editMsg = e.target.closest('[data-edit-message]');
        if (editMsg) {
          e.preventDefault();
          this.close();
          setTimeout(() => {
            const ta = document.querySelector('[data-card-message]');
            if (ta) {
              ta.scrollIntoView({ behavior: 'smooth', block: 'center' });
              ta.focus();
            }
          }, 320);
        }
      });
    }

    _listenForOpen() {
      document.addEventListener('tayf:open-cart', async () => {
        this.drawer.classList.add('is-loading');
        await this._refresh();
        this.drawer.classList.remove('is-loading');
        this.open();
      });

      document.addEventListener('click', e => {
        if (e.target.closest('[data-tayf-cart-trigger]')) {
          document.dispatchEvent(new CustomEvent('tayf:open-cart'));
        }
      });
    }

    open() {
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      this.overlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';

      const firstFocusable = this.drawer.querySelector('button:not([disabled]), a[href], input:not([disabled])');
      if (firstFocusable) firstFocusable.focus();
    }

    close() {
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      this.overlay.classList.remove('is-visible');
      document.body.style.overflow = '';
    }

    async _refresh() {
      try {
        const res = await fetch('/cart?sections=tayf-cart-drawer');
        const data = await res.json();
        const html = data['tayf-cart-drawer'];
        if (!html) return;

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newInner = doc.querySelector('[data-cart-inner]');
        const newFooter = doc.querySelector('[data-cart-footer]');
        const newCount = doc.querySelector('[data-cart-count]');

        const inner = this.drawer.querySelector('[data-cart-inner]');
        const footer = this.drawer.querySelector('[data-cart-footer]');
        const count = this.drawer.querySelector('[data-cart-count]');

        if (inner && newInner) inner.innerHTML = newInner.innerHTML;
        if (footer && newFooter) footer.outerHTML = newFooter.outerHTML;
        if (count && newCount) count.textContent = newCount.textContent;

        this._updateBubble(newCount ? newCount.textContent.replace(/[()]/g, '').trim() : '0');
      } catch (e) {
        console.error('[TayfCartDrawer] refresh failed', e);
      }
    }

    _updateBubble(countStr) {
      const count = parseInt(countStr, 10) || 0;
      document.querySelectorAll('.cart-bubble__text-count').forEach(el => {
        el.textContent = count;
      });
      document.querySelectorAll('.cart-bubble').forEach(el => {
        el.classList.toggle('visually-hidden', count === 0);
        const hidden = el.querySelector('.cart-bubble__text-count.hidden');
        if (hidden && count > 0) hidden.classList.remove('hidden');
      });
    }

    async _removeItem(key) {
      try {
        this.drawer.classList.add('is-loading');
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
        await this._refresh();
      } finally {
        this.drawer.classList.remove('is-loading');
      }
    }

    async _quickAdd(variantId) {
      try {
        this.drawer.classList.add('is-loading');
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        });
        await this._refresh();
      } finally {
        this.drawer.classList.remove('is-loading');
      }
    }
  }

  new TayfCartDrawer();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tayf-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  const section = document.querySelector('.tayf-coll[data-section-id]');
  if (!section) return;

  const PRICE_MAX = parseInt(section.dataset.priceMax || '2000', 10);

  const sidebar    = section.querySelector('[data-filter-sidebar]');
  const overlay    = document.querySelector('[data-filter-overlay]');
  const filterOpen = section.querySelectorAll('[data-filter-open]');
  const filterClose = section.querySelectorAll('[data-filter-close]');
  const applyBtn   = section.querySelector('[data-filter-apply]');
  const clearBtn   = section.querySelector('[data-filter-clear]');
  const sortSelect = section.querySelector('[data-sort-select]');
  const filterBadge = section.querySelector('[data-filter-badge]');
  const applyCount  = section.querySelector('[data-apply-count]');

  // Price slider
  const rangeMin   = section.querySelector('[data-range-min]');
  const rangeMax   = section.querySelector('[data-range-max]');
  const sliderFill = section.querySelector('[data-slider-fill]');
  const minValEl   = section.querySelector('[data-price-min-val]');
  const maxValEl   = section.querySelector('[data-price-max-val]');

  const filterTags = () => Array.from(section.querySelectorAll('[data-filter-tag]'));

  // ── Restore filter state from URL ─────────────
  function restoreFromURL() {
    const params = new URLSearchParams(window.location.search);

    // Tags
    const activeTags = params.getAll('filter.p.tag');
    filterTags().forEach(cb => {
      cb.checked = activeTags.includes(cb.value);
    });

    // Price
    const pMin = parseInt(params.get('filter.v.price.gte') || '0', 10);
    const pMax = parseInt(params.get('filter.v.price.lte') || String(PRICE_MAX), 10);
    if (rangeMin) rangeMin.value = Math.min(pMin, PRICE_MAX);
    if (rangeMax) rangeMax.value = Math.min(pMax, PRICE_MAX);
    updateSliderUI();
    updateBadge();
    updateApplyCount();
  }

  // ── Build and navigate to filter URL ──────────
  function buildURL() {
    const params = new URLSearchParams();

    const sort = sortSelect?.value;
    if (sort && sort !== 'best-selling') params.set('sort_by', sort);

    const pMin = parseInt(rangeMin?.value || '0', 10);
    const pMax = parseInt(rangeMax?.value || String(PRICE_MAX), 10);
    if (pMin > 0)          params.set('filter.v.price.gte', pMin);
    if (pMax < PRICE_MAX)  params.set('filter.v.price.lte', pMax);

    const seen = new Set();
    filterTags().forEach(cb => {
      if (cb.checked && !seen.has(cb.value)) {
        seen.add(cb.value);
        params.append('filter.p.tag', cb.value);
      }
    });

    const qs = params.toString();
    return window.location.pathname + (qs ? '?' + qs : '');
  }

  function applyFilters() {
    window.location.href = buildURL();
  }

  function clearFilters() {
    const params = new URLSearchParams();
    const sort = sortSelect?.value;
    if (sort && sort !== 'best-selling') params.set('sort_by', sort);
    const qs = params.toString();
    window.location.href = window.location.pathname + (qs ? '?' + qs : '');
  }

  // ── Active filter counts ───────────────────────
  function countActiveFilters() {
    const params = new URLSearchParams(window.location.search);
    let n = params.getAll('filter.p.tag').length;
    if (params.has('filter.v.price.gte') || params.has('filter.v.price.lte')) n++;
    return n;
  }

  function countPendingFilters() {
    let n = filterTags().filter(cb => cb.checked).length;
    const pMin = parseInt(rangeMin?.value || '0', 10);
    const pMax = parseInt(rangeMax?.value || String(PRICE_MAX), 10);
    if (pMin > 0 || pMax < PRICE_MAX) n++;
    return n;
  }

  function updateBadge() {
    const n = countActiveFilters();
    if (filterBadge) filterBadge.textContent = n || '';
  }

  function updateApplyCount() {
    const n = countPendingFilters();
    if (applyCount) applyCount.textContent = n > 0 ? n : '';
  }

  // ── Price slider ───────────────────────────────
  function updateSliderUI() {
    if (!rangeMin || !rangeMax) return;
    const lo = parseInt(rangeMin.value, 10);
    const hi = parseInt(rangeMax.value, 10);
    if (minValEl) minValEl.textContent = lo.toLocaleString();
    if (maxValEl) maxValEl.textContent = hi.toLocaleString();
    if (sliderFill) {
      sliderFill.style.left  = (lo / PRICE_MAX * 100) + '%';
      sliderFill.style.width = ((hi - lo) / PRICE_MAX * 100) + '%';
    }
  }

  function bindPriceSlider() {
    if (!rangeMin || !rangeMax) return;
    rangeMin.addEventListener('input', () => {
      if (parseInt(rangeMin.value, 10) > parseInt(rangeMax.value, 10)) {
        rangeMin.value = rangeMax.value;
      }
      updateSliderUI();
      updateApplyCount();
    });
    rangeMax.addEventListener('input', () => {
      if (parseInt(rangeMax.value, 10) < parseInt(rangeMin.value, 10)) {
        rangeMax.value = rangeMin.value;
      }
      updateSliderUI();
      updateApplyCount();
    });
    updateSliderUI();
  }

  // ── Sidebar open / close ───────────────────────
  function openSidebar() {
    sidebar.classList.add('is-open');
    sidebar.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    const first = sidebar.querySelector('button, input');
    if (first) requestAnimationFrame(() => first.focus());
  }

  function closeSidebar() {
    sidebar.classList.remove('is-open');
    sidebar.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  // ── Filter groups (collapse/expand) ──────���────
  function bindFilterGroups() {
    section.querySelectorAll('[data-filter-toggle]').forEach(btn => {
      btn.addEventListener('click', () => {
        const content = btn.closest('[data-filter-group]').querySelector('[data-filter-content]');
        const open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        content.classList.toggle('is-hidden', open);
      });
    });
  }

  // ── Checkbox change → update apply count ──────
  function bindFilterChecks() {
    filterTags().forEach(cb => cb.addEventListener('change', updateApplyCount));
  }

  // ── Init ──────────────────────────────────────
  filterOpen.forEach(btn => btn.addEventListener('click', openSidebar));
  filterClose.forEach(btn => btn.addEventListener('click', closeSidebar));
  if (overlay) overlay.addEventListener('click', closeSidebar);

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && sidebar?.classList.contains('is-open')) closeSidebar();
  });

  if (applyBtn) applyBtn.addEventListener('click', applyFilters);
  if (clearBtn) clearBtn.addEventListener('click', clearFilters);
  if (sortSelect) sortSelect.addEventListener('change', applyFilters);

  bindPriceSlider();
  bindFilterGroups();
  bindFilterChecks();
  restoreFromURL();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tayf-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  class TayfProduct {
    constructor(el) {
      this.el = el;
      this.sectionId = el.dataset.sectionId;
      const dataEl = document.getElementById('tayf-product-data-' + this.sectionId);
      if (!dataEl) return;
      this.data = JSON.parse(dataEl.textContent);
      this.variants = this.data.variants;
      this.selectedOptions = [];
      this.currentVariant = this.variants[0];

      this.initVariants();
      this.initGallery();
      this.initQuantity();
      this.initCardMessage();
      this.initForm();
      this.initStickyBar();
    }

    /* ── Variants ─────────────────────────── */
    initVariants() {
      const pills = this.el.querySelectorAll('.tayf-product__pill input');
      pills.forEach(input => {
        this.selectedOptions[parseInt(input.dataset.optionPosition)] = input.value;
        input.addEventListener('change', () => {
          this.selectedOptions[parseInt(input.dataset.optionPosition)] = input.value;
          const group = input.closest('.tayf-product__pills');
          group.querySelectorAll('.tayf-product__pill').forEach(p => p.classList.remove('is-active'));
          input.closest('.tayf-product__pill').classList.add('is-active');
          const label = this.el.querySelector('[data-selected-val="' + input.dataset.optionPosition + '"]');
          if (label) label.textContent = input.value;
          this.matchVariant();
        });
      });
      this.el.querySelectorAll('.tayf-product__pill input:checked').forEach(input => {
        this.selectedOptions[parseInt(input.dataset.optionPosition)] = input.value;
      });
      this.matchVariant();
    }

    matchVariant() {
      const matched = this.variants.find(v => {
        return this.selectedOptions.every((val, idx) => v['option' + (idx + 1)] === val);
      });
      if (matched) {
        this.currentVariant = matched;
        this.el.querySelector('[data-variant-input]').value = matched.id;
        this.updatePrice(matched);
        this.updateAtcState(matched);
      }
    }

    updatePrice(variant) {
      const display = this.el.querySelector('[data-price-display]');
      const compare = this.el.querySelector('[data-price-compare]');
      if (display) display.textContent = this.formatMoney(variant.price);
      if (compare) {
        if (variant.compare_at_price > variant.price) {
          compare.textContent = this.formatMoney(variant.compare_at_price);
          compare.hidden = false;
        } else {
          compare.hidden = true;
        }
      }
      this.updateTotal();
    }

    updateAtcState(variant) {
      const btn = this.el.querySelector('[data-atc-btn]');
      const stickyBtn = document.querySelector('[data-sticky-atc-btn]');
      const available = variant.available;
      if (btn) {
        btn.disabled = !available;
        btn.textContent = available ? btn.dataset.addToCartText : btn.dataset.soldOutText;
      }
      if (stickyBtn) {
        stickyBtn.disabled = !available;
        stickyBtn.textContent = available ? stickyBtn.dataset.addToCartText : stickyBtn.dataset.soldOutText;
      }
    }

    /* ── Gallery ─────────────────────────── */
    initGallery() {
      const thumbs = this.el.querySelectorAll('[data-thumb]');
      thumbs.forEach(thumb => {
        thumb.addEventListener('click', () => {
          const id = thumb.dataset.thumb;
          this.el.querySelectorAll('[data-main-media]').forEach(m => m.classList.remove('is-active'));
          this.el.querySelectorAll('[data-thumb]').forEach(t => t.classList.remove('is-active'));
          const target = this.el.querySelector('[data-main-media="' + id + '"]');
          if (target) target.classList.add('is-active');
          thumb.classList.add('is-active');
        });
      });
    }

    /* ── Quantity ─────────────────────────── */
    initQuantity() {
      const input = this.el.querySelector('[data-qty-input]');
      const dec = this.el.querySelector('[data-qty-dec]');
      const inc = this.el.querySelector('[data-qty-inc]');
      if (!input) return;

      dec.addEventListener('click', () => {
        const val = parseInt(input.value, 10);
        if (val > 1) { input.value = val - 1; this.updateTotal(); }
      });
      inc.addEventListener('click', () => {
        input.value = parseInt(input.value, 10) + 1;
        this.updateTotal();
      });
      input.addEventListener('change', () => {
        if (parseInt(input.value, 10) < 1) input.value = 1;
        this.updateTotal();
      });
    }

    /* ── Card message ─────────────────────── */
    initCardMessage() {
      const textarea = this.el.querySelector('[data-card-message]');
      const counter = this.el.querySelector('[data-char-count]');
      const preview = this.el.querySelector('[data-preview-text]');
      if (!textarea) return;

      textarea.addEventListener('input', () => {
        const len = textarea.value.length;
        if (counter) counter.textContent = len;
        if (preview) {
          preview.textContent = textarea.value || 'Your message will appear here…';
          preview.style.opacity = textarea.value ? '1' : '0.7';
          preview.style.fontStyle = textarea.value ? 'normal' : 'italic';
        }
      });
    }

    /* ── Total ─────────────────────────── */
    updateTotal() {
      const display = this.el.querySelector('[data-total-display]');
      const stickyPrice = document.querySelector('[data-sticky-price]');
      const qtyEl = this.el.querySelector('[data-qty-input]');
      const qty = parseInt(qtyEl ? qtyEl.value : 1, 10);
      const total = this.currentVariant.price * qty;
      const formatted = this.formatMoney(total);
      if (display) display.textContent = formatted;
      if (stickyPrice) stickyPrice.textContent = formatted;
    }

    /* ── Form ─────────────────────────── */
    initForm() {
      const form = this.el.querySelector('.tayf-product__form');
      if (!form) return;

      form.addEventListener('submit', async e => {
        e.preventDefault();
        const btn = this.el.querySelector('[data-atc-btn]');
        if (btn) { btn.disabled = true; btn.textContent = btn.dataset.addingText || 'Adding…'; }

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(form)
          });
          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.description || 'Add to cart failed');
          }
          document.dispatchEvent(new CustomEvent('tayf:open-cart'));
        } catch (err) {
          console.error('[TayfProduct] add to cart error', err);
        } finally {
          if (btn) {
            btn.disabled = !this.currentVariant.available;
            btn.textContent = this.currentVariant.available ? 'Add to Cart' : 'Sold Out';
          }
        }
      });
    }

    /* ── Sticky bar ─────────────────────── */
    initStickyBar() {
      const bar = document.querySelector('[data-sticky-atc]');
      const gallery = this.el.querySelector('[data-gallery]');
      if (!bar || !gallery) return;

      const stickyBtn = bar.querySelector('[data-sticky-atc-btn]');
      const formBtn = this.el.querySelector('[data-atc-btn]');

      if (stickyBtn && formBtn) {
        stickyBtn.addEventListener('click', () => formBtn.click());
      }

      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) {
            bar.classList.add('is-visible');
            bar.setAttribute('aria-hidden', 'false');
          } else {
            bar.classList.remove('is-visible');
            bar.setAttribute('aria-hidden', 'true');
          }
        });
      }, { threshold: 0.1 });

      observer.observe(gallery);
    }

    /* ── Money format ─────────────────── */
    formatMoney(cents) {
      const amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
      return 'AED ' + amount;
    }
  }

  document.querySelectorAll('[data-section-id]').forEach(el => {
    if (el.classList.contains('tayf-product')) new TayfProduct(el);
  });

  /* ── Lightbox ─────────────────────── */
  (function initLightbox() {
    const lightbox = document.querySelector('[data-lightbox]');
    if (!lightbox) return;

    const img = lightbox.querySelector('[data-lightbox-img]');
    const closeBtn = lightbox.querySelector('[data-lightbox-close]');
    const backdrop = lightbox.querySelector('[data-lightbox-backdrop]');

    function openLightbox(src, alt) {
      img.src = src;
      img.alt = alt || '';
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    }

    function closeLightbox() {
      lightbox.hidden = true;
      document.body.style.overflow = '';
      img.src = '';
    }

    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('[data-lightbox-trigger]');
      if (trigger) {
        openLightbox(trigger.dataset.lightboxSrc, trigger.dataset.lightboxAlt);
      }
    });

    closeBtn.addEventListener('click', closeLightbox);
    backdrop.addEventListener('click', closeLightbox);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !lightbox.hidden) {
        closeLightbox();
      }
    });
  })();

  /* ── Related products ─────────────── */
  (function initRelatedProducts() {
    const container = document.querySelector('[data-related-products]');
    if (!container) return;

    const productId = container.dataset.productId;
    const sectionId = container.dataset.sectionId;
    if (!productId || !sectionId) return;

    const url = '/recommendations/products?section_id=' + sectionId
      + '&product_id=' + productId
      + '&limit=4&intent=related';

    fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const inner = doc.querySelector('[data-related-products]');
        if (inner && inner.innerHTML.trim() !== '') {
          container.innerHTML = inner.innerHTML;
        }
      })
      .catch(function (err) {
        console.warn('[TayfProduct] recommendations fetch error', err);
      });
  })();

})();

  } catch(e) { console.error(e); }
})();
})();
